/**
 * Aligns custom product-card price areas within each visible collection grid row.
 */
class CollectionProductCardGrid {
  #animationFrame;

  #resizeObserver = new ResizeObserver(() => this.#scheduleAlignment());

  #mutationObserver = new MutationObserver(() => this.#scheduleAlignment());

  constructor(grid) {
    this.grid = grid;
    this.#resizeObserver.observe(grid);
    this.#mutationObserver.observe(grid, { childList: true });
    document.fonts?.ready?.then(() => this.#scheduleAlignment());
    this.#scheduleAlignment();
  }

  #scheduleAlignment() {
    cancelAnimationFrame(this.#animationFrame);
    this.#animationFrame = requestAnimationFrame(() => this.#alignPricing());
  }

  #alignPricing() {
    const cards = [...this.grid.querySelectorAll('.product-grid__item')].filter((card) =>
      card.querySelector(':scope > .site-product')
    );
    const rows = new Map();

    cards.forEach((card) => {
      const pricing = card.querySelector('.site-product__pricing');
      if (!pricing) return;

      pricing.style.minHeight = '';
      const row = Math.round(card.getBoundingClientRect().top);
      rows.set(row, [...(rows.get(row) || []), pricing]);
    });

    rows.forEach((pricingAreas) => {
      const tallestPricing = Math.max(...pricingAreas.map((pricing) => pricing.getBoundingClientRect().height));
      pricingAreas.forEach((pricing) => {
        pricing.style.minHeight = `${tallestPricing}px`;
      });
    });
  }
}

document.querySelectorAll('[data-collection-product-card-grid]').forEach((grid) => {
  new CollectionProductCardGrid(grid);
});
